export default __webpack_public_path__ + "static/media/small.49796d39.jpg";